import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  trackAddToCollection,
  trackFolderNameClick,
  trackNotificationChangeFolderClick,
  trackNotificationSaveToFolderClick,
} from './tracking';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { FoldersNotification } from '../../components/FoldersNotification';
import { selectResults } from '../../selectors';
import { refreshFolders } from '../../thunk/favorites';
import { trackCreateFolder } from '../FoldersList/create/tracking';
import { trackRemoveFromFolder } from '../MassActions/remove/tracking';

export function FoldersNotificationContainer() {
  const dispatch = useDispatch();
  const { favoriteEntities } = useSelector(selectResults);

  const handleSave = React.useCallback(() => {
    trackAddToCollection(favoriteEntities);
    dispatch(fetchFavoriteEntities({ offset: 0, limit: favoriteEntities.length }));
    dispatch(refreshFolders());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteEntities]);

  const handleCreate = React.useCallback(() => {
    trackCreateFolder(favoriteEntities);
    dispatch(refreshFolders());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteEntities]);

  const handleRemove = React.useCallback(() => {
    trackRemoveFromFolder(favoriteEntities);
    dispatch(refreshFolders());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteEntities]);

  const handleClickFolderName = React.useCallback(
    (offerId: number, folderId: number) => {
      trackFolderNameClick(offerId, folderId, favoriteEntities);
    },
    [favoriteEntities],
  );

  const handleNotificationChangeFolder = React.useCallback(() => {
    trackNotificationChangeFolderClick(favoriteEntities);
  }, [favoriteEntities]);

  const handleNotificationSaveToFolder = React.useCallback(() => {
    trackNotificationSaveToFolderClick(favoriteEntities);
  }, [favoriteEntities]);

  return (
    <FoldersNotification>
      <FavoritesAssignWidgetContainer
        isAuthenticated={true}
        onCreateFolder={handleCreate}
        onSaveOffer={handleSave}
        onRemovedFromFolders={handleRemove}
        onClickFolderName={handleClickFolderName}
        onNotificationChangeFolder={handleNotificationChangeFolder}
        onNotificationSaveToFolder={handleNotificationSaveToFolder}
      />
    </FoldersNotification>
  );
}
